var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLeft = function SvgIconLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.607 17.92c-.39 0-.76-.153-1.047-.478-.554-.607-.513-1.561.062-2.147l7.777-7.763a1.395 1.395 0 0 1 2.031.065c.554.607.513 1.561-.061 2.147l-7.777 7.763a1.4 1.4 0 0 1-.985.412"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.384 25.77c-.349 0-.718-.13-.985-.412l-7.777-7.872a1.573 1.573 0 0 1-.041-2.147 1.377 1.377 0 0 1 2.031-.044l7.777 7.872c.575.586.595 1.54.041 2.147-.287.304-.656.477-1.046.477z"
  })));
};
export default SvgIconLeft;